import {useEffect, useState} from 'react';

import * as Sentry from '@sentry/react';
import {models} from 'powerbi-client';
import {useLocation} from 'react-router-dom';

import {EMBED_REPORT_DEFAULT_SETTINGS as defaultSettings, CHATBOT_SIDEBAR_WIDTH} from '../../../const';

export default function useResponsiveReportSettings({windowSize, isChatbotSidebarOpen, selectedReport, reportSelectedPage}) {
  const [reportSettings, setReportSettings] = useState(defaultSettings);
  const [pageBeforeReload, setPageBeforeReload] = useState(null);

  const location = useLocation();

  useEffect(() => {
    const desktopAspectRatio = 4 / 3;
    const widthAvailable = isChatbotSidebarOpen ? windowSize.width - CHATBOT_SIDEBAR_WIDTH : windowSize.width;
    const currentAspectRatio = widthAvailable / windowSize.height;

    const newSettings = currentAspectRatio < desktopAspectRatio ? {...defaultSettings, layoutType: models.LayoutType.MobilePortrait} : {...defaultSettings, layoutType: models.LayoutType.Master};

    const breakpointHasChanged = newSettings.layoutType !== reportSettings.layoutType;

    if (breakpointHasChanged) {
      try {
        setPageBeforeReload(reportSelectedPage);
        setReportSettings(newSettings);
        selectedReport?.updateSettings(newSettings);
        selectedReport?.reload();
      } catch (e) {
        console.error(e);
        Sentry.captureException(e);
      }
    }
  }, [windowSize, isChatbotSidebarOpen, selectedReport, reportSelectedPage]);

  useEffect(() => {
    setPageBeforeReload(null);
  }, [location.pathname]);

  return {reportSettings, pageBeforeReload};
}
